import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_API_KEY = '/serviceJob/summary';

const emptySummary: Api.IServiceJobSummary = {
	totalJobs: 0,
	completedJobs: 0,
	totalAmount: 0,
};

export const useServiceJobSummaryQuery = ({
	filterRequest,
	enabled,
	refetchOnWindowFocus = false,
}: {
	filterRequest: Api.IServiceJobFilterRequest;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			const value = await userSession.webServiceHelper.callAsync<Api.IServiceJobSummary>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'ServiceJob/summary',
				}),
				'POST',
				filterRequest
			);
			return value ?? emptySummary;
		},
		queryKey: [BASE_API_KEY, filterRequest],
		refetchOnWindowFocus,
	});
};

export const invalidateAllServiceJobSummary = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY] });
};
